<template>
  <div class="page flex-col">
    <div class="totop">
      <a class="text_2" href="#subtabAt1" title="回到顶部"></a>
    </div>

    <div class="box_1 flex-col">
      <div class="group_1 flex-col">
        <div class="group_2 tags flex-row" id='subtabAt1'>
          <div class="sub-tag-0"></div>
          <div class="sub-tag">
            <img class="image_1" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngba28bc90435a2c263fc6e66a6c9c581123b5ed902b111f615ee35b22b274e77c.png" />
            <a class="text_1" href="http://www.kuandeng.com?id=1">主页</a>
          </div>
          <div class="sub-tag">
            <img class="image_2" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngba28bc90435a2c263fc6e66a6c9c581123b5ed902b111f615ee35b22b274e77c.png" />
            <a class="text_2" href="#subtabAt1">宽凳智路</a>
          </div>
          <div class="sub-tag">
            <img class="image_3" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngba28bc90435a2c263fc6e66a6c9c581123b5ed902b111f615ee35b22b274e77c.png" />
            <a class="text_2" href="#subtabAt2">解决方案</a>
          </div>
          <div class="sub-tag">
            <img class="image_4" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngba28bc90435a2c263fc6e66a6c9c581123b5ed902b111f615ee35b22b274e77c.png" />
            <a class="text_2" href="#subtabAt3">核心业务</a>
          </div>
          <div class="sub-tag">
            <img class="image_5" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngba28bc90435a2c263fc6e66a6c9c581123b5ed902b111f615ee35b22b274e77c.png" />
            <a class="text_5" href="#subtabAt4">合作伙伴</a>
            <img class="image_6" referrerpolicy="no-referrer"
              src="./assets/img/SketchPngba28bc90435a2c263fc6e66a6c9c581123b5ed902b111f615ee35b22b274e77c.png" />
          </div>
        </div>
        <span class="text_7">宽凳智路</span>
        <span class="slogon">
          致力于推动交通行业数字化转型，助力交通基础设施数据底座建设，赋能道路AI标注、智慧巡查、智慧养护，为交通行业高质量发展贡献宽凳力量。
        </span>
      </div>
    </div>
    <div class="box_3 flex-col">
      <div class="block_1 flex-col">
        <div v-show="!isShowVideo" class="image-wrapper_1 flex-col">
          <button @click="handleLoadVideo()" class="label_1"></button>
        </div>
        <div v-show="isShowVideo" style="width: 100%;height: 100%;">
          <!-- <video id="example_video_1" ref="videoRef" 
        class="video-js vjs-default-skin" 
        controls preload="auto" width="100%" height="100%;" 
        poster="./assets/img/SketchPngd96bcf8289260389357d56cbcde9d05a9cdc8e6f3735f70bc8a20a7531b7af1c.png" 
        data-setup="{}" style="object-fit:fill">  
				<source src="./assets/play/playlist.m3u8" type="application/x-mpegURL" />
				<p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p>
			</video> -->
          <video ref="videoRef" style="object-fit: fill; width: 100%; height: 100%"
            class="video-js vjs-fill video-iri"></video>
        </div>
      </div>
      <div class="block_2 flex-row justify-between">
        <div class="box_4 flex-col">
          <div class="box_5 flex-col"></div>
        </div>
        <div class="box_6 flex-col">
          <img class="image_8" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng83d30c63ec277077f4bfa80571e6a212ddc37978fcff696d9db5a9d194acf48a.png" />
          <span class="text_9" id="subtabAt2">解决方案</span>
        </div>
      </div>
      <div class="block_3 flex-col"></div>
      <div class="block_4 flex-row justify-between">
        <div class="group_3 flex-col justify-between">
          <div class="block_5 flex-row justify-between">
            <div class="group_4 flex-col">
            </div>
            <span class="text_10">小凳智巡</span>
          </div>
          <div class="text-wrapper_1">
            <span class="text_11">“小凳智巡”</span>
            <span class="text_12">
              ——
              宽凳科技自主研发的新一代公路智能巡查系统。本系统基于人工智能、雷达视觉融合、高精动态巡查等前沿科学技术，集车载AI巡查设备、道路智能巡查系统、宽凳智能云于一体，内置多重高精度算法适配高速/国省道/市政道路巡查、农村公路路况自动化检测等业务场景，自动识别和定位道路路面病害、交安设施缺损、道路施工、道路标志标线和抛洒物，实现巡查与检测结果的自动化量化输出，支持后台规划线路、远程查看、统计分析和任务派单，大幅提升了路面养护、巡查、测量、数据质检和问题上报等业务效率，为用户实现智慧养护、科学决策提供了重要依据。
            </span>
          </div>
        </div>
        <div class="group_6 flex-col">
          <div class="image-wrapper_2a flex-row">
            <div class="image-wrapper_2 flex-col">
              <img class="image_9" referrerpolicy="no-referrer" src="./assets/img/front-camera.png" />
            </div>
            <div class="image-wrapper_3 flex-col justify-between">
              <img class="image_10" referrerpolicy="no-referrer" src="./assets/img/edge-box.png" />
            </div>
            <div class="image-wrapper_3a flex-col justify-between">
              <img class="image_11" referrerpolicy="no-referrer" src="./assets/img/back-camera.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="block_6 flex-row justify-between">
        <div :class="'section_1 flex-col kdZoomIn ' + (activeZoomIn == 'more' ? 'active' : '')  "
          @mouseenter="handleZoomInEnter('more')">
          <div class="section_more_bg flex-col">
            <div class="box_7 flex-row justify-between">
              <div class="image-text_1 flex-row justify-between describtion">
                <div class="section_more flex-col"></div>
                <span class="text-group_1">设备功能</span>
              </div>
              <span class="text_13 flex-col">多</span>
            </div>
            <div class="section_more flex-col digest"></div>
            <span class="text_more flex-col digest">设备功能</span>
            <div class="text-wrapper_2 flex-row describtion">
              <span class="paragraph_1">
                ·&nbsp;路面病害检测
                <br />
                ·&nbsp;道路交安事件巡查
                <br />
                ·&nbsp;地图和道路资产数据采集
              </span>
            </div>
          </div>
        </div>
        <div :class="'section_3 flex-col kdZoomIn ' + (activeZoomIn == 'fast' ? 'active' : '')  "
          @mouseenter="handleZoomInEnter('fast')">
          <div class="section_fast_bg flex-col">
            <div class="box_7 flex-row justify-between">
              <div class="image-text_1 flex-row justify-between describtion">
                <div class="section_fast flex-col"></div>
                <span class="text-group_1">交付速度</span>
              </div>
              <span class="text_13 flex-col">快</span>
            </div>
            <div class="section_fast flex-col digest"></div>
            <span class="text_more flex-col digest">交付速度</span>
            <div class="text-wrapper_2 flex-row describtion">
              <span class="paragraph_1">
                ·&nbsp;外业采集速度是传统设备的2+倍
                <br />
                ·&nbsp;内业T+3输出标准模版检测报告
              </span>
            </div>
          </div>
        </div>
        <div :class="'section_4 flex-col kdZoomIn ' + (activeZoomIn == 'great' ? 'active' : '')  "
          @mouseenter="handleZoomInEnter('great')">
          <div class="section_great_bg flex-col">
            <div class="box_7 flex-row justify-between">
              <div class="image-text_1 flex-row justify-between describtion">
                <div class="section_great flex-col"></div>
                <span class="text-group_1">成果质量</span>
              </div>
              <span class="text_13 flex-col">好</span>
            </div>
            <div class="section_great flex-col digest"></div>
            <span class="text_more flex-col digest">成果质量</span>
            <div class="text-wrapper_2 flex-row describtion">
              <span class="paragraph_1">
                ·&nbsp;人工智能自动化识别<br />
                ·&nbsp;精度高、质量稳定<br />
                ·&nbsp;数据符合报部要求</span>
            </div>
          </div>
        </div>
        <div :class="'section_6 flex-col kdZoomIn ' + (activeZoomIn == 'economic' ? 'active' : '')  "
          @mouseenter="handleZoomInEnter('economic')">
          <div class="section_economic_bg flex-col">
            <div class="box_7 flex-row justify-between">
              <div class="image-text_1 flex-row justify-between describtion">
                <div class="section_economic flex-col"></div>
                <span class="text-group_1">综合成本</span>
              </div>
              <span class="text_13 flex-col">省</span>
            </div>
            <div class="section_economic flex-col digest"></div>
            <span class="text_more flex-col digest">综合成本</span>
            <div class="text-wrapper_2 flex-row describtion">
              <span class="paragraph_1">·&nbsp;设备成本低<br />
                ·&nbsp;使用成本低<br />
                ·&nbsp;人力投入低</span>

            </div>
          </div>
        </div>

      </div>
      <div class="image-text_2 flex-row justify-between">
        <div class="marker flex-col out">
          <div class="in"></div>
        </div>
        <span class="text-group_2">应用场景</span>
      </div>
      <div class="block_9 flex-row justify-between">
        <div class="box_8 flex-col">
          <span class="text_20">农村公路路况自动化检测</span>
          <div class="text-wrapper_3 flex-col"><span class="text_21">01</span></div>
          <img class="label_3" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngb56001b9d56e69bb4a2398086e1e63809479cda56286787115347849408da441.png" />
        </div>
        <div class="box_9 flex-col">
          <span class="text_22">高速/国省道/农村公路巡查</span>
          <div class="text-wrapper_4 flex-col"><span class="text_23">02</span></div>
          <img class="label_4" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng5c27eedcbba4b85705b248dee1a5c34e224f1746ffab97547f2f84b86988ac75.png" />
        </div>
        <div class="box_10 flex-col">
          <span class="text_24">市政道路巡查</span>
          <div class="text-wrapper_5 flex-col"><span class="text_25">03</span></div>
          <img class="label_5" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngd9af9f07d5661272d7fc8181ebe7e0a2326c0296ccdb83edad44b34e986bb8b8.png" />
        </div>
        <div class="box_11 flex-col">
          <span class="text_26">道路基础数据采集与更新</span>
          <div class="text-wrapper_6 flex-col"><span class="text_27">04</span></div>
          <img class="label_6" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng2f3a60debb2e830e803fd31250e03b78f777d5bca1dfa9aafb9c97a5d47a4ffe.png" />
        </div>
      </div>
      <div class="block_9_xs flex-row justify-between">
        <div class="block_9_xs_div flex-col">

          <span><img referrerpolicy="no-referrer"
              src="./assets/img/SketchPngb56001b9d56e69bb4a2398086e1e63809479cda56286787115347849408da441.png" />
            农村公路路况自动化检测</span>

          <span><img referrerpolicy="no-referrer"
              src="./assets/img/SketchPng5c27eedcbba4b85705b248dee1a5c34e224f1746ffab97547f2f84b86988ac75.png" />
            高速/国省道/农村公路巡查</span>

          <span><img referrerpolicy="no-referrer"
              src="./assets/img/SketchPngd9af9f07d5661272d7fc8181ebe7e0a2326c0296ccdb83edad44b34e986bb8b8.png" />
            市政道路巡查</span>

          <span><img referrerpolicy="no-referrer"
              src="./assets/img/SketchPng2f3a60debb2e830e803fd31250e03b78f777d5bca1dfa9aafb9c97a5d47a4ffe.png" />
            道路基础数据采集与更新</span>
        </div>
      </div>
    </div>
    <div class="box_12 flex-col">
      <div class="block_10 flex-col">
        <div class="box_13 flex-row justify-between">
          <img class="image_13" referrerpolicy="no-referrer" src="./assets/img/kdrmms.jpg" />
          <div class="block_11 flex-col justify-between">
            <div class="block_12 flex-row justify-between">
              <div class="block_13 flex-col">
              </div>
              <span class="text_28">数字公路一张图</span>
            </div>
            <div class="text-wrapper_7">
              <span class="text_29">数字公路一张图</span>
              <span class="text_30">
                ——
                基于先进的低成本高精度图像建模技术，宽凳科技突破性地将高精地图技术应用于交通运输管理和公路基础设施数字化领域，推出数字公路一张图方案，以高精地图为载体，融合无人飞机、车路协同、数字孪生等先进技术与数据，厘米级定位、毫米级测量，精度高、要素全、更新快，为交通主管部门和业主打造一体化的公路基础数据底座，可广泛应用于对交通流量、设施、病害、养护、应急的高精化动态管理，为“智慧公路”和“农村公路一路一档”建设提供有力支撑。
              </span>
            </div>
          </div>
        </div>
        <div class="image-text_3 flex-row justify-between">
          <div class="marker flex-col out">
            <div class="in"></div>
          </div>
          <span class="text-group_3">宽凳数字公路一张图——服务于公路全生命周期数字化管理</span>
        </div>
        <div class="box_15 flex-row">
          <div class="box_16 flex-col">
            <span class="text_31">数据采集</span>
            <div class="text-wrapper_8 flex-col"></div>
            <span class="text_sub_txt">快速采集道路数据，实现资产数字化、可视化，服务建设验收</span>
          </div>
          <div class="box_17 flex-col"></div>
          <div class="box_18 flex-col">
            <span class="text_34">数字化管理</span>
            <div class="text-wrapper_9 flex-col"></div>
            <span class="text_sub_txt">加快数字化转型，实现精准感知、精确分析、精细管理</span>
          </div>
          <div class="box_19 flex-col"></div>
          <div class="box_20 flex-col">
            <span class="text_37">智慧养护</span>
            <div class="text-wrapper_10 flex-col"></div>
            <span class="text_sub_txt">结合基础数据与巡查数据，支撑养护决策、优化资金利用</span>
          </div>
          <div class="box_21 flex-col"></div>
          <div class="box_22 flex-col">
            <span class="text_40">路网监测</span>
            <div class="text-wrapper_11 flex-col"></div>
            <span class="text_sub_txt">及时更新路网数据，提升道路安全运行能力和交通承载力</span>
          </div>
        </div>
        <div class="box_23 flex-row justify-between">
          <div class="image-text_4 flex-row justify-between">
            <div class="marker flex-col out">
              <div class="in"></div>
            </div>
            <span class="text-group_4">宽凳数字公路一张图应用实践</span>
          </div>
          <div class="image-text_5 flex-row justify-between">
            <div class="marker flex-col out">
              <div class="in"></div>
            </div>
            <span class="text-group_5">应用场景</span>
          </div>
        </div>
        <div class="box_24 flex-row justify-between">
          <div class="group_10 flex-col"></div>
          <div class="grid_1 flex-row">
            <div class="box_25 flex-col">
              <div class="box_26 flex-row justify-between">
                <img class="image_14" referrerpolicy="no-referrer"
                  src="./assets/img/SketchPngced6007810a3e927477733a5604f1eb7e9eeeaa34eb8830ed38fe3a5786334d8.png" />
                <span class="text_43">01</span>
              </div>
              <div class="text-wrapper_12 flex-row"><span class="text_44">公路资产管理与分析</span></div>
            </div>
            <div class="box_27 flex-col">
              <div class="block_15 flex-row justify-between">
                <img class="image_15" referrerpolicy="no-referrer"
                  src="./assets/img/SketchPng140522cc591e59a44b3f47a62fc18bb6a1aa10aff76cc268ca10e0f6766c2086.png" />
                <span class="text_45">02</span>
              </div>
              <div class="text-wrapper_13 flex-row"><span class="text_46">公路智慧养护与运营</span></div>
            </div>
            <div class="box_28 flex-col">
              <div class="block_16 flex-row justify-between">
                <img class="image_16" referrerpolicy="no-referrer"
                  src="./assets/img/SketchPngca2312b54ba92e28303e4c484a634bcd3231817781879db72e4688fe5382e8b6.png" />
                <span class="text_47">03</span>
              </div>
              <span class="text_48">农村公路一路一档建设</span>
            </div>
            <div class="box_29 flex-col">
              <div class="block_17 flex-row justify-between">
                <div class="block_18 flex-col"></div>
                <span class="text_49">04</span>
              </div>
              <span class="text_50">多源异构基础数据融合</span>
            </div>
          </div>
          <div class="grid_1_xs flex-row">
          </div>
        </div>
      </div>
    </div>
    <div class="box_30 flex-col">
      <div class="box_31 flex-row justify-between">
        <div class="block_19 flex-col">
          <div class="group_11 flex-col"></div>
        </div>
        <div class="block_20 flex-col">
          <img class="image_18" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng83d30c63ec277077f4bfa80571e6a212ddc37978fcff696d9db5a9d194acf48a.png" />
          <span class="text_51" id="subtabAt3">核心业务</span>
        </div>
      </div>
      <div class="box_32 flex-col"></div>
      <div class="image-text_6 flex-row justify-between">
        <div class="marker flex-col out">
          <div class="in"></div>
        </div>
        <span class="text-group_6">农村公路路况自动化检测</span>
      </div>
      <div class="box_34 flex-row justify-between">
        <div class="group_12 flex-col">
          <div class="group_12_a flex-row">
          </div>
          <div class="group_13 flex-row">
            <div class="text-wrapper_14 flex-col"><span class="text_52">30万+</span></div>
            <span class="text_53 flex-col">全国农村公路路况自动化检测服务公里数</span>
          </div>
        </div>
        <div class="group_14 flex-col">
          <div class="group_15 flex-row">
            <div class="image-text_7 flex-row">

              <div class="image-text_12 flex-row justify-between">
                <div class="text-wrapper_15">
                  <div class="at3_detail_txt"><span class="_before-cont"></span><span class="_b mk">适用路面类型：</span><span
                      class="_c">沥青及水泥路面</span>
                  </div>
                  <div class="at3_detail_txt"><span class="_before-cont"></span><span class="_b mk">检测类型：</span><span
                      class="_c">路面病害与平整度</span>
                  </div>
                  <div class="at3_detail_txt"><span class="_before-cont"></span><span class="_b mk">病害可识别类型：</span><span
                      class="_c">沥青路面：横纵裂缝、网裂、坑槽、修补</span></div>
                  <div class="at3_detail_txt"><span class="_b "></span><span class="_c">水泥路面：裂缝、破碎版、坑洞、修补</span>
                  </div>
                  <div class="at3_detail_txt"><span class="_b"></span><span class="_c">可人工核实自动化结果并自定义编辑（例如松散、露骨等）</span>
                  </div>
                  <div class="at3_detail_txt"><span class="_before-cont"></span><span class="_b mk">识别准召率：</span><span
                      class="_c">综合不低于
                      90%，裂缝类病害不低于 95%</span></div>
                  <div class="at3_detail_txt"><span class="_before-cont"></span><span class="_b mk">采集要求：</span><span
                      class="_c">路面无积水或积雪，车辆可按道路限速行驶</span></div>
                  <div class="at3_detail_txt"><span class="_before-cont"></span><span class="_b mk">时效性：</span><span
                      class="_c">边缘处理器快速处理数据，成果数据回传云端后72小时内输出数据结果</span></div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="box_35 flex-row justify-between">
        <div class="section_10 flex-col">
          <div class="group_16 flex-col"></div>
        </div>
        <div class="section_11 flex-col">
          <div class="section_12 flex-row">
            <div class="box_36 flex-col"></div>
            <span class="text_63">景观图像</span>
            <div class="box_37 flex-col"></div>
            <span class="text_64">路面图像</span>
            <span class="text_65">桩段：K0+096&nbsp;&nbsp;DR：15.53&nbsp;&nbsp;IRI：4.14</span>
          </div>
          <div class="section_13 flex-row justify-between">

          </div>
        </div>
      </div>
      <div class="box_39 flex-col">
        <div class="group_18 flex-row">
          <div class="box_40 flex-col">
            <div class="text-wrapper_16 flex-col"><span class="text_67">“小凳智巡”</span></div>
            <div class="section_14 flex-col">
              <div class="group_19 flex-row justify-between">
                <div class="group_20 flex-col"></div>
                <div class="group_21 flex-col"></div>
              </div>
              <div class="group_22 flex-row">
                <div class="image-text_13 flex-row">
                  <div class="image-text_14 flex-row justify-between">
                    <div class="box_41 flex-col"></div>
                    <span class="paragraph_7">
                      采购成本低，使用成本低
                      <br />
                      一车一人即可操作
                    </span>
                  </div>
                  <div class="box_42 flex-col"></div>
                </div>
              </div>
              <div class="group_23 flex-row justify-between">
                <div class="box_43 flex-col"></div>
                <div class="box_44 flex-col"></div>
              </div>
            </div>
            <div class="section_15 flex-col">
              <div class="group_24 flex-row justify-between">
                <div class="box_45 flex-col"></div>
                <div class="box_46 flex-col"></div>
              </div>
              <div class="group_25 flex-row">
                <div class="image-text_15 flex-row">
                  <div class="image-text_16 flex-row">
                    <div class="image-text_17 flex-row justify-between">
                      <div class="box_47 flex-col"></div>
                      <span class="paragraph_8">
                        设备不挑车，适应各种路况
                        <br />
                        支持断点采集，降低空驶率
                        <br />
                        支持路网导航，采集速度是传统检测设备的2+倍
                      </span>
                    </div>
                    <div class="section_16 flex-col"></div>
                  </div>
                  <div class="group_26 flex-col"></div>
                </div>
              </div>
              <div class="group_27 flex-row justify-between">
                <div class="group_28 flex-col"></div>
                <div class="group_29 flex-col"></div>
              </div>
            </div>
            <div class="section_17 flex-col">
              <div class="box_48 flex-row justify-between">
                <div class="group_30 flex-col"></div>
                <div class="group_31 flex-col"></div>
              </div>
              <div class="box_49 flex-row">
                <div class="image-text_18 flex-row justify-between">
                  <div class="box_50 flex-col"></div>
                  <span class="text-group_7">病害全自动化识别处理，数据/报表/报告自动输出，效率高、数据准确</span>
                </div>
              </div>
              <div class="box_51 flex-row justify-between">
                <div class="block_23 flex-col"></div>
                <div class="block_24 flex-col"></div>
              </div>
            </div>
          </div>
          <div class="box_52 flex-col">
            <div class="box_53 flex-col"></div>
            <div class="box_54 flex-col"></div>
            <div class="box_55 flex-col"></div>
          </div>
          <div class="box_56 flex-col">
            <div class="text-wrapper_17 flex-col"><span class="text_68">农村公路路况自动化检测“痛点”</span></div>
            <div class="text-wrapper_18 flex-col"><span class="text_69">预算低、人手少</span></div>
            <div class="text-wrapper_19 flex-col"><span class="text_70">路难采、效率低</span></div>
            <div class="text-wrapper_20 flex-col"><span class="text_71">工期紧、标准高</span></div>
          </div>
          <div class="box_57 flex-col"></div>
        </div>
      </div>
      <div class="box_39_xs">
        <div class="box_39_xs_kdms"></div>
        <div class="box_39_xs_kdms2"></div>
      </div>
    </div>
    <div class="box_58 flex-col">
      <div class="image-text_19 flex-row justify-between">
        <div class="marker flex-col out">
          <div class="in"></div>
        </div>
        <span class="text-group_8">高速/国省道/农村公路/市政道路巡查</span>
      </div>
      <div class="grid_2 flex-row">
        <div class="group_32 flex-col"></div>
        <div class="group_33_xs flex-row">
          <img class="thumbnail_19" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
          <span class="paragraph_9">
            基于SLAM和组合惯导实现高精定位</span>
          <br />
          <img class="thumbnail_19" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
          <span class="paragraph_9">数据成果可编辑、可测量、可扩展</span>
          <br />
          <img class="thumbnail_19" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
          <span class="paragraph_9">交安设施、病害、事件全要素智能识别，属地化AI闭环提高准召率</span>
          <br />
          <img class="thumbnail_19" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
          <span class="paragraph_9">一次采集多结果输出，服务多业务场景，形成高鲜度高精数据底座
          </span>
        </div>
        <div class="group_33 flex-row">
          <div class="image-wrapper_7 flex-col justify-between">
            <img class="thumbnail_19" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
            <img class="thumbnail_20" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
            <img class="thumbnail_21" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
            <img class="thumbnail_22" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
          </div>
          <span class="paragraph_9">
            基于SLAM和组合惯导实现高精定位
            <br />
            数据成果可编辑、可测量、可扩展
            <br />
            交安设施、病害、事件全要素智能识别，属地化AI闭环提高准召率
            <br />
            一次采集多结果输出，服务多业务场景，形成高鲜度高精数据底座
          </span>
        </div>
        <div class="group_34 flex-col">
          <div class="box_59 flex-row justify-between">
            <img class="thumbnail_23" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
            <span class="text_72">适用路面场景：</span>
          </div>
          <div class="box_60 flex-row justify-between">
            <div class="image-wrapper_8 flex-col justify-between">
              <img class="thumbnail_24" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
              <img class="thumbnail_25" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
            </div>
            <div class="text-wrapper_21 flex-row">
              <span class="paragraph_10">
                高速公路、国省道、农村公路、市政道路
                <br />
                <br />
                标志标牌损坏、遮挡、倾倒、防护设施破损
                <br />
                路面抛洒物、积雪、水毁、落石、道路施工等
                <br />
                路面巡检事件类型可实现定制化训练，完成模型识别的迭代更新
                <br />
                <br />
                沥青路面横纵裂缝、网裂、坑槽、修补
                <br />
                水泥路面裂缝、破碎版、坑洞、修补
                <br />
                可人工核实自动化结果并自定义编辑（例如松散、露骨等）
              </span>
              <span class="text_73">巡检事件识别类型：</span>
              <span class="text_74">病害识别类型：</span>
            </div>

          </div>
        </div>

        <div class="group_34_xs flex-col">
          <div class="box_59 flex-row justify-between">
            <img class="thumbnail_23" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
            <span class="text_72">适用路面场景：</span>
            <span class="paragraph_10">
              高速公路、国省道、农村公路、市政道路</span>
            <img class="thumbnail_23" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
            <span class="text_72">巡检事件识别类型：</span>
            <span class="paragraph_10">
              标志标牌损坏、遮挡、倾倒、防护设施破损
              <br />
              路面抛洒物、积雪、水毁、落石、道路施工等
              <br />
              路面巡检事件类型可实现定制化训练，完成模型识别的迭代更新
            </span>
            <img class="thumbnail_23" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6cc313bd71be0ec1eea898f4527998cd254c8add5639beb4aebfbcf50813db67.png" />
            <span class="text_72">病害识别类型：</span>
            <span class="paragraph_10">
              沥青路面横纵裂缝、网裂、坑槽、修补
              <br />
              水泥路面裂缝、破碎版、坑洞、修补
              <br />
              可人工核实自动化结果并自定义编辑（例如松散、露骨等）
            </span>

          </div>
        </div>
        <div class="group_35 flex-col"></div>
      </div>
    </div>
    <div class="box_61 flex-col">
      <div class="image-text_20 flex-row justify-between">
        <div class="marker flex-col out">
          <div class="in"></div>
        </div>
        <span class="text-group_9">农村公路“一路一档”数字化应用支撑</span>
      </div>
      <img class="image_20" referrerpolicy="no-referrer"
        src="./assets/img/SketchPnge6a6908b213c3ebb5fdea05b09f8508cfbe483daabe3c45833d7267cc477f0c4.png" />
    </div>
    <div class="box_63 flex-col">
      <div class="block_26 flex-row justify-between">
        <div class="section_18 flex-col">
          <div class="section_19 flex-col"></div>
        </div>
        <div class="section_20 flex-col">
          <img class="image_21" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng83d30c63ec277077f4bfa80571e6a212ddc37978fcff696d9db5a9d194acf48a.png" />
          <span class="text_75" id="subtabAt4">合作伙伴</span>
        </div>
      </div>
      <div class="block_27 flex-col"></div>
      <div class="grid_3 flex-row">
        <div class="image-wrapper_9 flex-col">
          <img class="image_22" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngd9bd24a476806b69f8bc3c4aad17ab6445b9601237545d3a57d95af66f07c290.png" />
        </div>
        <div class="box_64 flex-row">
          <div class="group_36 flex-col"></div>
          <div class="group_37 flex-col"></div>
        </div>
        <div class="image-wrapper_10 flex-col">
          <img class="image_23" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng87907a4b551f1c90d20b972554c176f173ddc55e07fbe78e285742904eb2592e.png" />
        </div>
        <div class="image-wrapper_11 flex-col">
          <img class="image_24" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngea429440991db2526652044f0bfb84259725e43aaa99a135d48fb67f9999ec9a.png" />
        </div>
        <div class="image-wrapper_12 flex-col">
          <img class="image_25" referrerpolicy="no-referrer"
            src="./assets/img/SketchPnga8f752c1e5181b59fec6498207ed241d9b9012b3771e9675fd82d2d8d849909f.png" />
        </div>
        <div class="image-wrapper_13 flex-col">
          <img class="image_26" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngf7b27f655bc087d7936db0f4a02fcfb45c5034e522d336f01b41a3336bb9b432.png" />
        </div>
        <div class="image-wrapper_14 flex-col">
          <img class="image_27" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng7da2b64085dd065e339463c37ac7c6e02e0a7edcee99fa3b234e96642ed7dc7c.png" />
        </div>
        <div class="image-wrapper_15 flex-col">
          <img class="image_28" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng7cf749a01d6af3ca5c624229913a8d12e9fde48c1dc569632811efeb52b380a2.png" />
        </div>
        <div class="image-wrapper_16 flex-col">
          <img class="image_29" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngab87abf786d4f786c046a2b6d25aa624ea94fa70afafa263f87de2b29791c614.png" />
        </div>
        <div class="image-wrapper_17 flex-col">
          <img class="image_30" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngd482428c11ede40e3ef3413a471537cfbc3cfd1dc9361beefa4554aacf5cb293.png" />
        </div>
        <div class="image-wrapper_18 flex-col">
          <img class="image_31" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngd690b3c406458df4e1b3a470f6d3aa2dc741c5078360fac1b94f552ee6454762.png" />
        </div>
        <div class="image-wrapper_19 flex-row">
          <img class="image_32" referrerpolicy="no-referrer"
            src="./assets/img/cabae13bc793465a86226dd98cf88cc1_mergeImage.png" />
          <img class="image_33" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng58ac3510fe49a0f5adb3ea5ad70dcf8df3e541b933e91522bad0ac10ebb17374.png" />
        </div>
        <div class="image-wrapper_20 flex-col">
          <img class="image_34" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngdb2f7464dcaa6fadbbeacb7137d6bd7804aef0bdb8bc29b6a8f10f87a29b485f.png" />
        </div>
        <div class="image-wrapper_21 flex-col">
          <img class="image_35" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng274b3293f7eb25a1274b7d7cb3a078a0eafb25d80c7d196d45c438a989c13e53.png" />
        </div>
        <div class="image-wrapper_22 flex-col">
          <img class="image_36" referrerpolicy="no-referrer"
            src="./assets/img/SketchPngb17dd239cffd06088911896759bc7f35dfb992d99d5da28c6ef6b38b9c80cc61.png" />
        </div>
        <div class="image-wrapper_23 flex-col">
          <img class="image_37" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng519f001b4215b4bbcf7e95a97d751f5dc43827db24a0c70e17865599222b9c09.png" />
        </div>
        <div class="box_65 flex-col">
          <div class="block_28 flex-col"></div>
        </div>
        <div class="box_66 flex-col">
          <div class="block_29 flex-col"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
export default {
  data() {
    return {
      constants: {},
      activeZoomIn: 'more',
      isShowVideo: false,
      src:'',
    };
  },
  methods: {
    handleZoomInEnter(key) {
      this.activeZoomIn = key
    },
    handleLoadVideo(){
      this.isShowVideo = true
      this.handelPlay()
    },
    handelPlay(){
      if (!this.$refs.videoRef) {
        return
      }
      this.initVideoPlayer()
    },

    initVideoPlayer(){
        let _style = {
            autoplay: true,
            bigPlayButton:false,
            controls: true,
            controlBar: {
                    volumePanel: true,
                    pictureInPictureToggle: false,
                    fullscreenToggle: true,
                    remainingTimeDisplay: true
            },
            fill: true, 
            muted: true,
            loop: false, // 导致视频一结束就重新开始。
            notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
            sources: [{
                // src: 'play/playlist.m3u8',
                src: 'kdzlmini.mp4',
                // type: 'application/x-mpegURL'
                type:'video/mp4'
            }],
        };
       
        let _videoNode = this.$refs.videoRef;
        if(!_videoNode){
            return
        }
        let _player = videojs(_videoNode, _style, function onPlayerReady() {
            console.log('onPlayerReady');
        });

        window.player = _player;
        // let _this = this;

        // let $this = this;
        // this.player.on('loadeddata', (e) => {
        //     // 计算editcanvas的一些参数
        //     let videoHeight = _this.videoNode.clientHeight;
        //     let videoWidth = _this.videoNode.clientWidth;
        //     let wScale = _this.videoNode.clientWidth / _this.videoNode.videoWidth;
        //     let hScale = _this.videoNode.clientHeight / _this.videoNode.videoHeight;
        //     // console.log(videoWidth, videoHeight, wScale, hScale)
        //     _this.setState({ isVideoReady: true, videoHeight: videoHeight, videoWidth: videoWidth, wScale: wScale, hScale: hScale });
        // });
        // this.player.on("timeupdate", function (eve) {
        //     let currentTime = _this.player.currentTime();
        //     _this.refreshKChart({currentTime}) 
        // });
        // this.player.on("ratechange", function (eve) {
        //     // let playbackRate = _this.player.playbackRate();
        //     // _this.refreshKChart({playbackRate})
        //     _this.refreshKChart({})
        // });
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.normal.css" />
<style scoped lang="css" src="./assets/index.xs.css" />